<template>
    <b-button class="back-button" v-if="step._back_button_visible" :disabled="block_form" @click="goBack">
        <b-icon class="arrow-left" icon="arrow-left"></b-icon>
        <span class="back-text">Retour</span>
    </b-button>
</template>

<script>
import mixin from "../../../components/form/steps/travel_step_mixin";

export default {
    mixins: [mixin],
}
</script>
